<template>
  <section class="h-full w-full flex flex-col">
      <div :style="backgroundStyle" class="ht-auto sm:ht-300 md:ht-350 lg:ht-400 xl:ht-500 2xl:ht-600 w-full bg-cover bg-no-repeat bg-center relative bg-image">
      </div>
      <div class="w-full mt-8 px-8">
        <div class="container mx-auto">
          <bread-crumb :items="breadCrumbItems"></bread-crumb>
        </div>
      </div>
      <div class="px-8 my-8">
          <div class="container mx-auto">
              <div class="bg-1 text-white px-4 py-2 text-2xl font-bold flex items-center">
                <icon-back @click.stop="$router.go(-1)" class="zoom-in"></icon-back>
                <h1 class="ml-2">Alumni Success Stories</h1>
              </div>
              <div v-if="$apollo.queries.successStories.loading && page == 1">
                <story-card-shimmer class="mt-8" v-for="(story, index) in first" :key="index"></story-card-shimmer>
              </div>
              <div v-else>
                <story-card class="mt-8" v-for="(story, index) in getSuccessStories" :key="index" :item="story" :is-read-more="true"></story-card>
                <div v-if="showViewMoreButton" class="flex justify-center mt-8">
                  <div @click="loadMore" class="border border-primary text-white hover:text-primary view-all bg-primary hover:bg-white transition-all duration-200 px-4 py-2 cursor-pointer">View More</div>
                </div>
              </div>
              <div class="w-full flex justify-end mt-8">
                  <back-button></back-button>
              </div>
          </div>
      </div>
  </section>
</template>

<script>
import gql from 'graphql-tag';
import StoryCard from "../../components/success-stories/StoryCard.vue";
import StoryCardShimmer from "../../components/success-stories/StoryCardShimmer.vue";
import IconBack from "../../components/icons/IconBack.vue";
import backgroundImage from '../../assets/images/success_stories/img1.png';
import BreadCrumb from  "../../components/shared/BreadCrumb.vue";

const itemPerPage = 10;

export default {
    name: "success-stories",
    components: { 
        StoryCard,
        StoryCardShimmer,
        IconBack,
        BreadCrumb,
    },
    data() {
        return {
            successStories: [],
            first: itemPerPage,
            page: 1,
            breadCrumbItems: [
                { label: 'Home', path: '/' },
                { label: 'Success Stories' },
            ],
        };
    },
    computed: {
      backgroundStyle () {
        return {
          'background-image': `url(${backgroundImage})`
        }
      },
      getSuccessStories() {
        return this.successStories.data;
      },
      showViewMoreButton() {
        return this.successStories.paginatorInfo.hasMorePages;
      },
    },
    apollo: {
        successStories () {
            return {
                query: gql`query GetPageSuccessStories($first: Int!, $page: Int!) {
                    successStories(first: $first, page: $page) {
                        data {
                            name
                            description
                            id
                            thumbnail
                            title
                            entity {
                                logo
                                entity
                            }
                        }
                        paginatorInfo {
                            count
                            currentPage
                            firstItem
                            hasMorePages
                            lastItem
                            lastPage
                            perPage
                            total
                        }
                    }
                }`,
                variables () {
                    return {
                        first: itemPerPage,
                        page: 1,
                    }
                },
                // fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
      loadMore() {
        this.page += 1;
        this.$apollo.queries.successStories.fetchMore({
          variables: {
            first: this.first,
            page: this.page,
          },

          updateQuery: (previousResult, { fetchMoreResult }) => {

            const newSuccessStories = fetchMoreResult.successStories.data;
            const newPaginatorInfo = fetchMoreResult.successStories.paginatorInfo;

            return {
              successStories: {
                __typename: previousResult.successStories.__typename,
                data: [...previousResult.successStories.data, ...newSuccessStories],
                paginatorInfo: newPaginatorInfo,
              }
            }
            
          }
        })
      },
    },

}
</script>
<style lang="scss" scoped>
.bg-1 {
  background: linear-gradient(90deg, rgba(34,42,57,1) 0%, rgba(10,66,117,1) 100%);
}
@responsive {
    .ht-auto {
        height: auto;
    }
    .ht-600 {
        height: 600px;
    }
    .ht-500 {
        height: 500px;
    }
    .ht-400 {
        height: 400px;
    }
    .ht-350 {
        height: 350px;
    }
    .ht-300 {
        height: 300px;
    }
}
.bg-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.text-shadow {
  text-shadow: -1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black;
}
</style>